import { z } from "zod"

/** The largest client logo the API keeps, as a data URL. The browser draws
    the site's icon to a small PNG first, so a real one is a few KB. The
    database holds the same limit as a check. */
export const CLIENT_LOGO_MAX_CHARS = 32_768

/** A client's own website, as the firm typed it. */
export const ClientWebsiteSchema = z.string().trim().min(3).max(255)

/** The name on the client's paperwork, when it differs from what the firm
    calls them. Only the firm sees it. */
export const ClientLegalNameSchema = z.string().trim().min(1).max(200)

export const ClientLogoDataUrlSchema = z
  .string()
  .max(CLIENT_LOGO_MAX_CHARS, "Use a smaller logo.")
  .regex(/^data:image\/png;base64,[A-Za-z0-9+/]+={0,2}$/, "Use a PNG logo.")

export const ClientBrandColorSchema = z
  .string()
  .regex(/^#[0-9a-fA-F]{6}$/, "Use a six-digit hex color.")

/** What a firm keeps about how a client looks: set by the wizard's website
    lookup and changed later in the client's Details. Null clears a field. */
export const ClientBrandFieldsSchema = z.object({
  clientWebsite: ClientWebsiteSchema.nullable().optional(),
  clientLegalName: ClientLegalNameSchema.nullable().optional(),
  clientLogoDataUrl: ClientLogoDataUrlSchema.nullable().optional(),
  clientBrandColor: ClientBrandColorSchema.nullable().optional(),
})

export type ClientBrandFields = z.infer<typeof ClientBrandFieldsSchema>
